import { useCallback } from 'react';
import { Journeys, Targets, useCrossFlow } from '@atlassiansox/cross-flow-support';
import { Behaviours, Prompts, TargetTabs } from '@atlassiansox/cross-flow-extensions/types';
import { createProvisioningApiExtensions } from '@atlassiansox/cross-flow-extensions/ProvisioningApiExtensions';

export const useOpenCrossFlow = (): (() => void) => {
	const crossFlow = useCrossFlow();
	const templateId = 'jpd.product-roadmap';
	const extensions = createProvisioningApiExtensions({
		actions: {
			primary: {
				behaviour: Behaviours.LAND,
				prompt: Prompts.NEXT,
				options: {
					targetTab: TargetTabs.SAME,
					urlParams: { templateId },
				},
			},
		},
		jobName: 'activate-and-ensure-project-created',
		jobParams: {
			sourceComponent: 'jiraNavigation',
			sourceContext: 'roadmaps',
		},
	});

	return useCallback(() => {
		crossFlow.isEnabled &&
			crossFlow.apiV1.open({
				journey: Journeys.GET_STARTED,
				targetProduct: Targets.JIRA_PRODUCT_DISCOVERY,
				sourceComponent: 'jiraNavigation',
				sourceContext: 'roadmaps',
				extensions,
				v1: true,
			});
	}, [crossFlow, extensions]);
};
